import React, { type ReactElement } from 'react';
import TooltipItem from 'atom-components/tooltip-item';
import BaseMarkerBadge from 'feature-components/badges/marker-badges/base-marker-badge';
import type { GroupMembersProps } from './group-members';
import type { GroupMemberFormValue } from './marking-group-form.schema';
import { GroupMemberType } from './marking-group-form.schema';

type GroupMemberMarkerBadgeProps = {
  groupMember: GroupMemberFormValue;
} & GroupMembersProps;

export default function GroupMemberMarkerBadge({
  groupMember,
  groupMemberType,
  organisationUsers
}: GroupMemberMarkerBadgeProps): ReactElement {
  const organisationUser = organisationUsers.find((ou) => ou.id === groupMember.organisationUserId);

  const tooltip =
    `@${organisationUser?.user.username}` +
    `${
      groupMemberType === GroupMemberType.NonMarker
        ? ' has non-marker roles only that are not supported by marking groups.'
        : ''
    }`;

  return (
    <TooltipItem tooltip={tooltip}>
      <BaseMarkerBadge
        organisationUser={organisationUser}
        // Display an orange warning if the user is in the non-marker list. This is
        // because non-markers aren't normally marking group members.
        displayWarning={groupMemberType === GroupMemberType.NonMarker}
        // Badge is not used in the context of a marking task, so ignore mark or
        // response specific props:
        defaultMarkerToOrganisationUser
        activeMarker={undefined}
        autoscored={false}
        omitTooltip // Omit the default tooltip since we're defining a custom tooltip here.
      />
    </TooltipItem>
  );
}
